/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:04]
Permissions to update outside the main branch: [false]
*/

import { toFloat } from '@finbeat/react-toolkit';
import { SelectOption } from 'models/api/prop';
import { useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { Col, Row } from 'reactstrap';
import ProcedureParamInput from './ProcedureParamInput';
import { TariffProcedureParamFormType } from './TariffProcedureParamChangeModal';
import { useTariffProcedureParamsWorkplaceState } from './TariffProcedureParams';

const TariffProcedureParamsList = ({
    getDefaultParams,
    getCurrentParams,
    disabled,
}: {
    getDefaultParams: (procedureId: number) => {
        procedureParamId: number;
        paramValue: string | boolean;
        selectOptions: SelectOption[];
        paramName: string;
        type: string;
    }[];
    getCurrentParams: () => {
        id: number | undefined;
        procedureParamId: number;
        paramValue: string | boolean;
        selectOptions: SelectOption[];
        paramName: string;
        type: string;
    }[];
    disabled: boolean;
}) => {
    const { watch } = useFormContext<TariffProcedureParamFormType>();
    const procedureId = watch('procedureId').toString(); // in fact watch returns string;
    const { currentItem } = useTariffProcedureParamsWorkplaceState();

    const { fields, append, remove } = useFieldArray<TariffProcedureParamFormType, 'params', 'id2'>(
        {
            name: 'params',
            keyName: 'id2',
        }
    );

    useEffect(() => {
        remove();
        append(
            currentItem && currentItem.procedureId.toString() === procedureId
                ? getCurrentParams()
                : getDefaultParams(toFloat(procedureId) || 0)
        );
    }, [procedureId, currentItem]);

    return (
        <>
            {fields.map((p, i) => (
                <Row key={p.id} className="mb-3">
                    <Col>
                        <ProcedureParamInput
                            label={p.paramName}
                            selectOptions={p.selectOptions}
                            type={p.type}
                            name={`params.${i}.paramValue`}
                            disabled={disabled}
                        />
                    </Col>
                </Row>
            ))}
        </>
    );
};

export default TariffProcedureParamsList;
